import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { MaintenanceTable } from '../../Layouts/DataTable';
import { EApiType, EDataMaintenanceType, EModuleType } from '../../../data/Constants';
import { getCountryList } from '../../../store/states/MarketSlice';
import { getPriceListMap } from '../../../store/states/PriceSlice';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'store';
import { useApiError } from '../../../hooks';

import type { IManagementProps } from '../../../../types';

export const PriceListMap = (props: IManagementProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const errorElement = useApiError(EApiType.PriceListMapKey);

  useEffect(() => {
    dispatch(getCountryList({ token: props.token }));
  }, []);

  if (errorElement) return errorElement;

  return (
    <>
      <h3 className="mainHeader"> {t('header.priceListMap')} </h3>
      <MaintenanceTable
        token={props.token}
        type={EDataMaintenanceType.PriceListMap}
        getDataList={getPriceListMap}
        moduleType={EModuleType.Datamaintainance}
      />
    </>
  );
};
